import Vue from 'vue'

export default {
    resetStateMutation(state) {
        Vue.set(state, "labTableShow", true);
        Vue.set(state, "labFormShow", false);
        Vue.set(state, "patientLabTableShow", false);
        Vue.set(state, "patientLabFormShow", false);
    },
    showLabTable(state) {
        state.labTableShow = true;
        state.labFormShow = false;
        state.patientLabTableShow = false;
        state.patientLabFormShow = false;
    },
    showLabForm(state) {
        state.labTableShow = false;
        state.labFormShow = true;
        state.patientLabTableShow = false;
        state.patientLabFormShow = false;
    },
    showPatientLabTable(state) {
        state.labTableShow = false;
        state.labFormShow = false;
        state.patientLabTableShow = true;
        state.patientLabFormShow = false;
    },
    showPatientLabForm(state) {
        state.labTableShow = false;
        state.labFormShow = false;
        state.patientLabTableShow = false;
        state.patientLabFormShow = true;
    }
}
